import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarMonthCellFn = /* @__PURE__ */ createRecipe('calendar-month-cell', {}, [])

const calendarMonthCellVariantMap = {}

const calendarMonthCellVariantKeys = Object.keys(calendarMonthCellVariantMap)

export const calendarMonthCell = /* @__PURE__ */ Object.assign(memo(calendarMonthCellFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarMonthCell',
  __getCompoundVariantCss__: calendarMonthCellFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarMonthCellVariantKeys,
  variantMap: calendarMonthCellVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarMonthCellVariantKeys)
  },
  getVariantProps: calendarMonthCellFn.getVariantProps,
})